let language = {
    STORE_PRODUCT_LIST_EMPTY_DES1:"点击",
    STORE_PRODUCT_LIST_EMPTY_DES2:"这里",
    STORE_PRODUCT_LIST_EMPTY_DES3:"查看我们的目录，并选择您想提供给客户的产品。您可以通过添加您的设计或允许您的客户在您的商店中使用他们的设计来定制产品。 "

};

export { language }